import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { FaCalendarAlt, FaUserCircle, FaUsers, FaCalendarCheck } from "react-icons/fa";
import constants from "../../../constants";
import LoadMoreList from "../../../services/LoadMoreList";
import { checkIfFileIsaDocument } from "../../../services/FileOperationGlobalFunctions";
import GlobalViewFileModal from "../../../services/GlobalViewFileModal";
import { redirectUrl } from "../../../services/GlobalUrls";
const TimeSheetsListMobile = (props) => {
  const [timesheets, SetTimeSheets] = useState([]);
  const [modalOption, setModalOption] = useState(false);
  const [modalHeight, setModalHeight] = useState("500px");
  const [fileUrl, setFileUrl] = useState("");
  const [setFileName] = useState("");

  useEffect(() => {
    SetTimeSheets(props.timesheets);
  }, [props.timesheets]);
  const viewFileModal = (url, fileName) => {
    if (checkIfFileIsaDocument(url)) {
      setModalHeight("500px");
      setFileUrl(url);
      setFileName(fileName);
    } else {
      redirectUrl(url);
    }
  };

  const callModal = () => {
    document.getElementById("loader").style.display = "block";
    setModalOption(true);
  };
  const loaderEnd = () => {
    document.getElementById("loader").style.display = "none";
    setModalHeight("auto");
  };

  const closeFileModal = () => {
    setModalOption(false);
    setFileUrl("");
  };

  //   Filter - Start
  const [inputValue, setInputValue] = useState("");
  const matchesSearchText = (timesheet) => {
    const searchText = inputValue.toLowerCase();
    return (
      timesheet.cnd_timesheet_created_date.toLowerCase().includes(searchText) ||
      timesheet.fullname.toLowerCase().includes(searchText) ||
      timesheet.cnd_timesheet_client_name.toLowerCase().includes(searchText) ||
      timesheet.cnd_timesheet_week_commencing
        .toLowerCase()
        .includes(searchText) ||
      timesheet.cnd_timesheet_status.toLowerCase().includes(searchText)
    );
  };

  // Filter applied jobs based on the search text
  const filterRows = timesheets ? timesheets.filter(matchesSearchText) : [];
  //   Filter - End

  return (
    <React.Fragment>
      <div className="m-b30 wrapper">
        <div className="container">
          <div className="row">
            <div className="col-sm-12">
             
              <div className="form-group form-group-default">
                <input
                  type="text"
                  name="search"
                  className="form-control "
                  placeholder="Enter here"
                  onInput={(event, value) => {
                    setInputValue(event.target.value);
                  }}
                />
              </div>
            </div>
          </div>
        </div>
        {/* Search End */}
        <div className="col-lg-12 col-md-12 m-b0 wrapper">
          <LoadMoreList
            data={filterRows}
            initialCount={5}
            noDataMessage="No Result Found"
            renderItem={(timesheet, i) => (
              <ul
                className="nav navbar-nav border border-grey p-4 mb-2"
                style={{ borderRadius: "20px" }}
                key={i}
              >
                <li className="text-dark">
                  <FaCalendarAlt className="mr-1 text-primary" />{" "}
                  {timesheet.cnd_timesheet_created_date}
                </li>
                <li className="text-dark">
                  <FaUserCircle className="mr-1 text-primary" />{" "}
                  {timesheet.fullname && timesheet.fullname.length <= 15
                    ? timesheet.fullname
                    : timesheet.fullname
                    ? timesheet.fullname.slice(0, 15) + "..."
                    : ""}
                  <a
                    onClick={() =>
                      viewFileModal(
                        constants.IMAGE_URL +
                          timesheet.cnd_timesheet_folderpath +
                          timesheet.cnd_timesheet_upload_document
                      )
                    }
                    className={
                      "text-" +
                      (timesheet.cnd_timesheet_upload_document.endsWith(
                        ".png"
                      ) ||
                      timesheet.cnd_timesheet_upload_document.endsWith(
                        ".jpg"
                      ) ||
                      timesheet.cnd_timesheet_upload_document.endsWith(
                        ".jpeg"
                      ) ||
                      timesheet.cnd_timesheet_upload_document.endsWith(".pdf")
                        ? "primary"
                        : "primary") +
                      " text-sm pull-right mt--2"
                    }
                  >
                    <u>View File</u>
                  </a>
                </li>
                <li className="text-dark">
                  <FaUsers className="mr-1 text-primary" />{" "}
                  {timesheet.cnd_timesheet_client_name &&
                  timesheet.cnd_timesheet_client_name.length <= 15
                    ? timesheet.cnd_timesheet_client_name
                    : timesheet.cnd_timesheet_client_name
                    ? timesheet.cnd_timesheet_client_name.slice(0, 15) + "..."
                    : ""}
                </li>
                <li className="text-dark">
                  <FaCalendarCheck className="mr-1 text-primary" />{" "}
                  {timesheet.cnd_timesheet_week_commencing}
                </li>
                <li className="text-dark">
                  <i className="fa fa-circle-o-notch mr-1 text-primary"></i>{" "}
                  {timesheet.cnd_timesheet_status}
                </li>
              </ul>
            )}
          />
          {/* <a
            href="#"
            onClick={documentsRequiredCall}
            className="pull-right btn btn-primary mr-2"
          >
            Next
          </a> */}
        </div>
      </div>
      <GlobalViewFileModal
        modalOption={modalOption}
        closeFileModal={closeFileModal}
        fileUrl={fileUrl}
        // fileName={fileName}
        loaderEnd={loaderEnd}
        modalHeight={modalHeight}
        callModal={callModal}
        title={"TimeSheet"}
      />
    </React.Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
    timesheets: state.timesheets.timesheets,
  };
};

export default connect(mapStateToProps)(TimeSheetsListMobile);
